import { render, staticRenderFns } from "./InvoiceTexts.vue?vue&type=template&id=ad23fe1c&scoped=true"
import script from "./InvoiceTexts.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceTexts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceTexts.vue?vue&type=style&index=0&id=ad23fe1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad23fe1c",
  null
  
)

export default component.exports